import { retrieveLaunchParams } from '@telegram-apps/sdk-react';

import { IosUserSelfie } from '@/components/ProfileData/Selfie/IosUserSelfie.tsx';
import { AndroidUserSelfie } from '@/components/ProfileData/Selfie/AndroidUserSelfie.tsx';
import { FileData } from '@/shared/interface/userRegistrationData.ts';
import { StepTitle } from '@/components/common/Steps/Steps.tsx';

type UserSelfie = {
  selfie?: FileData;
};

export type UserSelfieProps = UserSelfie & {
  updateFields: (fields: Partial<UserSelfie>) => void;
  onSubmit: () => void;
  isSubmitting?: boolean;
};

export function UserSelfie({
  selfie,
  updateFields,
  onSubmit,
  isSubmitting
}: UserSelfieProps) {
  const { tgWebAppPlatform } = retrieveLaunchParams();

  return (
    <>
      <StepTitle title="" />
      {tgWebAppPlatform === 'ios' ? (
        <IosUserSelfie
          selfie={selfie}
          updateFields={updateFields}
          onSubmit={onSubmit}
          isSubmitting={isSubmitting}
        />
      ) : (
        <AndroidUserSelfie
          selfie={selfie}
          updateFields={updateFields}
          onSubmit={onSubmit}
          isSubmitting={isSubmitting}
        />
      )}
    </>
  );
}
